/* eslint-disable object-curly-newline,no-undef */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { save } from '../../../reducers/workOrder/workOrders.actions';
import './WorkOrderApprove.css';

export const requiredValue = value => (value ? undefined : 'Required');

// eslint-disable-next-line react/prefer-stateless-function
export class ApproveWorkOrder extends React.Component {
  componentWillMount() {
    this.setState({ redirect: false });
    this.props.approve(this.props.match.params.id).then(() => this.setState({ redirect: true }));
  }

  render() {
    return (
      <span>{ this.state.redirect && <Redirect to={`/pm/workorders/${this.props.match.params.id}`} /> }</span>);
  }
}

ApproveWorkOrder.propTypes = {
  approve: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export const mapStateToProps = () => ({});

export const mapDispatchToProps = dispatch => ({
  approve: id => dispatch(save({ id, status: 'submitted' }, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApproveWorkOrder);



// WEBPACK FOOTER //
// ./src/components/ProjectManager/WorkOrderApprove/WorkOrderApprove.jsx